import styled from 'styled-components';

import { space } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';

const Selector = styled.ul`
  align-items: center;
  border-left: 1px solid ${colors.neutral[800]};
  display: inline-flex;
  margin: 0 0 0 ${space(2)};

  .language {
    color: ${colors.neutral[400]};
    font-weight: 400;
    margin: 0 ${space()} 0 ${space(2)};
    text-decoration: none;

    &:hover {
      color: ${colors.primary[600]};
    }
  }

  .active {
    color: ${colors.primary[600]};
  }
`;

export { Selector };
